import { render, staticRenderFns } from "./WalletDeposit.vue?vue&type=template&id=cc9a272a"
import script from "./WalletDeposit.vue?vue&type=script&lang=ts"
export * from "./WalletDeposit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports